import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated"  
import { getID } from "src/libs/utilities"


const infoGraphics = (): any[] => {
    return [ 
        {
          "id": getID("info-graphics"),
          "type": "info_graphics",
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay":ANIMATE_DELAY.WATERFALL ,
          "order": [ "image", "medallion", "title", "html" ],
          "vertical_align": "minimal",
          "border_radius": 8,
          "back_color": "var(--force-plain-opacity-color)",
          "silhouette": "hands-victory",
          "title": "Мошенники",
          "description": "Коренной национальности",
          "size": 400,
          "dotSize": 40,
          "silhouette_gap": 4,
          "gap": 30,
          "card_fields": [
            {
              "id": getID("image"),
              "type": "image",
              "hover_size": 20,
              "style": { "height": 160 }
            },
            {
              "id": getID("medallion"),
              "type": "medallion",
              "radius": 40,
              "icon": "https://i.pinimg.com/1200x/8c/6e/f2/8c6ef2716fe3e235e15e3e8c9bef4727.jpg",
              "margin": 0,
              "hover_size": -8,
              "color": "#FFFFFF"
            },
            { "id": getID("title"), "type": "title" },
            { "id": getID("html"), "type": "html" },
            {
              "id": getID("checkbox"),
              "type": "checkbox",
              "isHidden": 1,
              "tags": [],
              "style": { "marginBottom": 30 }
            },
            {
              "id": getID("cropped_divider"),
              "type": "cropped_divider",
              "isHidden": 1,
              "divider_type": "wave_outline_reverse",
              "divider_width": "100%",
              "divider_color": "#4a6471",
              "divider_height": 330
            },
            {
              "id": getID("personal_link"),
              "type": "personal_link",
              "personalLinkType": "outline",
              "style": {}
            },
            {
              "id": getID("inner_link"),
              "type": "inner_link",
              "isHidden": 1,
              "style": { "height": 115, "paddingBottom": 10 }
            }
          ],
          "cards": [
            {
              "id": getID("card"),
              "cardColor": "#3b291e66",
              "cardTitle": "Путь становления лингвистом",
              "cardDescription--": "Строительная отрасль во все времена была главнейшим направлением в развитии любой цивилизации.",
              "cardIcon": "fas fa-carrot",
              "width": 260,
              "value": [
                {
                  "id": getID("card-image"),
                  "data": "https://i.pinimg.com/1200x/bc/56/02/bc560298c9ad58b79a8ee52d9f74bc77.jpg"
                },
                {
                  "id": getID("card-medallion") ,
                  "data": "https://i.pinimg.com/1200x/4a/97/06/4a97062d4a2cf28405f8a08e3fc4b893.jpg"
                },
                { "id": getID("card-title"), "data": "Путь становления лингвистом" },
                {
                  "id": getID("card-html"),
                  "data": "<p>Строительная отрасль во все времена была главнейшим направлением в развитии любой цивилизации."
                },
                {
                  "id": "-a7ae46c8-5",
                  "data": [
                    { "checked": 1, "title": "Совершенно бесплатно" },
                    { "checked": 0, "title": "Вечно" },
                    { "checked": 0, "title": "Круглосуточная поддержка" },
                    { "checked": 0, "title": "Бутерброд в подарок" }
                  ]
                },
                { "id": getID("card"), "data": null },
                {
                  "id": getID("card-link"),
                  "data": {
                    "sc": {
                      "vk": "https://vk.com/feed?w=wall-1830250_17103",
                      "telegram": "https://te.me/341235677"
                    }
                  }
                },
                { "id": getID("card-btn"), "data": { "url": "/", "label": "Goto" } }
              ],
              "style": {}
            },
            {
              "id": getID("card"),
              "cardColor": "#6f776066",
              "cardTitle": "оя будущая профессия — военный инженер",
              "cardDescription--": "Очень распространённым штампом в романах-фэнтези является изображение медицины и процесса лечения",
              "cardIcon": "fas fa-boxes",
              "width": 260,
              "value": [
                {
                  "id": getID("card-image"),
                  "data": "https://i.pinimg.com/1200x/e3/ee/f4/e3eef4da1eb57db0d71d9574b6542f6e.jpg"
                },
                {
                  "id": getID("card-icon"),
                  "data": "https://i.pinimg.com/736x/5a/e6/c8/5ae6c82a4e0b510fcb39b7674627ca55.jpg"
                },
                {
                  "id": getID("card-title"),
                  "data": "Моя будущая профессия — инженер."
                },
                {
                  "id": getID("card-html"),
                  "data": "Очень распространённым штампом в романах-фэнтези является изображение медицины и процесса лечения, завязанного на суевериях и полуволшебных практиках."
                },
                {
                  "id": getID("card-checkbox"),
                  "data": [
                    { "checked": 1, "title": "Совершенно бесплатно" },
                    { "checked": 1, "title": "Вечно" },
                    { "checked": 1, "title": "Круглосуточная поддержка" },
                    { "checked": 0, "title": "Бутерброд в подарок" }
                  ]
                },
                { "id": getID("card-"), "data": null },
                {
                  "id": getID("card-link"),
                  "data": {
                    "sc": {
                      "dzen": "https://dzen.me/341235677",
                      "vk": "https://vk.com/feed?w=wall-1830250_17103",
                      "telegram": "https://ru.pinterest.com/pin/39688040460739816/",
                      "rutube": "https://rutube.ru/video/69cd337cda701e0f513626f107321c3c/"
                    }
                  }
                },
                { "id": getID("card-btn"), "data": { "url": "/", "label": "Goto" } }
              ],
              "style": {}
            },
            {
              "id": getID("card"),
              "cardColor": "#51729466",
              "cardTitle": "Вулканы Камчатки",
              "cardDescription--": "Обычно при упоминании о средневековых войсках вспоминаются либо крестоносцы",
              "cardIcon": "fas fa-smog",
              "width": 260,
              "value": [
                {
                  "id": getID("card-image"),
                  "data": "https://i.pinimg.com/1200x/77/d1/54/77d15495d2a1341e5db7629cccc3b90f.jpg"
                },
                {
                  "id": getID("card-icon"),
                  "data": "https://i.pinimg.com/736x/81/ac/95/81ac95e4285a7b7b8f51ddad5ab29514.jpg"
                },
                { "id": getID("card-title"), "data": "Вулканы Камчатки" },
                {
                  "id": getID("card-html"),
                  "data": "<p>Обычно при упоминании о средневековых войсках вспоминаются либо крестоносцы, либо просто рыцари, с ног до головы закованные в латы и сидящие на коне. "
                },
                {
                  "id": getID("card-checkbox"),
                  "data": [
                    { "checked": 1, "title": "Совершенно бесплатно" },
                    { "checked": 1, "title": "Вечно" },
                    { "checked": 1, "title": "Круглосуточная поддержка" },
                    { "checked": 1, "title": "Бутерброд в подарок" }
                  ]
                },
                {
                  "id": getID("card-"),
                  "data": null,
                  "style": { "fill": "red" }
                },
                {
                  "id": getID("card-link"),
                  "data": {
                    "sc": {
                      "vk": "https://vk.com/feed?w=wall-1830250_17103",
                      "telegram": "https://te.me/341235677",
                      "rutube": "https://rutube.ru/video/8dc31ae985fc043de3891e585e80c732/",
                      "odnoklassniki": "https://ok.ru/cinemastar/topic/156575933506371",
                      "at": "bobo@email.bo"
                    }
                  }
                },
                { "id": getID("card-btn"), "data": { "url": "/", "label": "Goto" } }
              ],
              "style": {}
            },
            {
              "id": getID("card"),
              "cardColor": "#0c51897d",
              "cardTitle": "Где и как этому учат Хобутаниди Диана",
              "cardDescription--": "Жара стихла (сегодня мне сказали, что дождя нет из-за того, что грешили много, о как)",
              "cardIcon": "fas fa-cat",
              "width": 260,
              "value": [
                {
                  "id": getID("card-image"),
                  "data": "https://i.pinimg.com/1200x/72/79/31/72793136020004e2ef5a4206946fbe73.jpg"
                },
                {
                  "id": getID("card-icon"),
                  "data": "https://i.pinimg.com/1200x/01/bd/fa/01bdfaf148d04e8e4a4464018cb6765c.jpg"
                },
                {
                  "id": getID("card-title"),
                  "data": "Где и как этому учат Хобутаниди Диана"
                },
                {
                  "id": getID("card-html"),
                  "data": "<p>Жара стихла (сегодня мне сказали, что дождя нет из-за того, что грешили много, о как), я отошел от подвигов и выбрался на базарчик."
                },
                {
                  "id": getID("card-checkbox"),
                  "data": [
                    { "checked": 1, "title": "Совершенно бесплатно" },
                    { "checked": 1, "title": "Вечно" },
                    { "checked": 1, "title": "Круглосуточная поддержка" },
                    { "checked": 1, "title": "Бутерброд в подарок" }
                  ]
                },
                { "id": getID("card-"), "data": null },
                {
                  "id": getID("card-links"),
                  "data": {
                    "sc": {
                      "vk": "https://vk.com/feed?w=wall-162479647_729613",
                      "odnoklassniki": "https://ok.ru/bstroyka",
                      "telegram": "https://te.me/341235677"
                    }
                  }
                },
                { "id": getID("card-btn"), "data": { "url": "/", "label": "Goto" } }
              ],
              "style": {}
            },
            {
              "id": getID("card"),
              "cardColor": "#548ab766",
              "cardTitle": "Патрики",
              "cardDescription--": "Мужчину в костюме лебедя",
              "cardIcon": "fas fa-dog",
              "width": 260,
              "value": [
                {
                  "id": getID("card-title"),
                  "data": "https://i.pinimg.com/1200x/11/a1/6e/11a16e465bd2cfe140bd6da01d89a01c.jpg"
                },
                {
                  "id": getID("card-icon"),
                  "data": "https://i.pinimg.com/736x/11/af/87/11af87e8690f61773f2b33aff802009e.jpg"
                },
                { "id": getID("card-title"), "data": "Патрики" },
                {
                  "id": getID("card-html"),
                  "data": "<p>Мужчину в костюме лебедя, который устроил заплыв на сапборде, задержали на Патриарших прудах."
                },
                {
                  "id": getID("car-checkbox"),
                  "data": [
                    { "checked": 1, "title": "Совершенно бесплатно" },
                    { "checked": 1, "title": "Вечно" },
                    { "checked": 1, "title": "Круглосуточная поддержка" },
                    { "checked": 1, "title": "Бутерброд в подарок" }
                  ]
                },
                { "id": getID("card-"), "data": null },
                {
                  "id": getID("card-link"),
                  "data": {
                    "sc": {
                      "vk": "https://vk.com/feed?w=wall-162479647_729613",
                      "odnoklassniki": "https://ok.ru/bstroyka",
                      "telegram": "https://te.me/341235677"
                    }
                  }
                },
                { "id": getID("card-btn"), "data": { "url": "/", "label": "Goto" } }
              ],
              "style": {}
            }
          ],
          "defaultTitle": "Карточки с миниатюрой и медальоном"
        }
    ]
}
export default infoGraphics